/* eslint-disable */

import { eventChannel, END } from 'redux-saga';
import { fork, all, takeEvery, put, call } from 'redux-saga/effects';
import _ from 'lodash';
import history from 'app/utils/history';
import {
  GET_PAYMENT_DETAILS,
  GET_PAYMENT_DETAILS_SUCCESS,
  GET_PAYMENT_DETAILS_FAIL,
  CHECK_USER_PAYMENT,
  CHECK_USER_PAYMENT_SUCCESS,
  CHECK_USER_PAYMENT_FAIL,
  CLEAR_PAYMENT_CHECK,
  SEND_PAYMENT_LINK,
  SEND_PAYMENT_LINK_SUCCESS,
  SEND_PAYMENT_LINK_FAIL,
} from './redux';
import Request from 'app/utils/xhrWrapper';

let channel = null;

function checkPaymentChannel() {
  return eventChannel(emitter => {
      const interval = setInterval(() => {
        const PAYMENT_DONE = localStorage.getItem('isPaymentDone') === 'true';
        emitter(PAYMENT_DONE);
        if (PAYMENT_DONE) {
          localStorage.removeItem('isPaymentDone');
          emitter(END);
        }
      }, 5000);
      return () => {
        clearInterval(interval);
      };
    },
  );
}

export function* getPaymentDetails() {
  yield takeEvery(GET_PAYMENT_DETAILS, function* () : any {
    try {
      const response = yield Request.get(`accounting/payment/pay_qrcode`);
      const responseData = _.get(response, ['data', 'attributes']);
      if (responseData) {
        yield put({ type: GET_PAYMENT_DETAILS_SUCCESS, data: responseData });
        channel = yield call(checkPaymentChannel);
        yield takeEvery(channel, function* (isPaymentDone) {
          if (isPaymentDone && history) {
            history.push(`/${history.location.pathname.split('/')[1]}`);
          } else {
            const checkUrlParts = responseData.extra.check_url.split('/');
            yield put({ type: CHECK_USER_PAYMENT, data: checkUrlParts[checkUrlParts.length - 1] });
          }
        });
      } else {
        yield put({ type: GET_PAYMENT_DETAILS_FAIL, data: {} });
      }
    } catch (error) {
      yield put({ type: GET_PAYMENT_DETAILS_FAIL, data: error });
    }
  });
}

export function* checkUserPayment() {
  yield takeEvery(CHECK_USER_PAYMENT, function* ({ data }) : any {
    try {
      const response = yield Request.get(`accounting/payment/pay_check/pay_userid/${data}`);
      const responseData = _.get(response, ['data', 'attributes']);
      if (responseData) {
        localStorage.setItem('isPaymentDone', 'true');
        yield put({ type: CHECK_USER_PAYMENT_SUCCESS, data: responseData });
      } else {
        yield put({ type: CHECK_USER_PAYMENT_FAIL, data: {} });
      }
    } catch (error) {
      yield put({ type: CHECK_USER_PAYMENT_FAIL, data: error });
    }
  });
}

export function* clearPayment() {
  yield takeEvery(CLEAR_PAYMENT_CHECK, function* () : any {
    channel.close();
  });
}

export function* sendPaymentLink() {
  yield takeEvery(SEND_PAYMENT_LINK, function* ({ data }) : any {
    const urlParts = data.split('/');
    const payId = urlParts[urlParts.length - 3];
    const payType = urlParts[urlParts.length - 1];
    try {
      const response = yield Request.get(`accounting/payment/send_pay_link/pay_userid/${payId}/type/${payType}`);
      const responseData = _.get(response, ['data', 'attributes']);
      if (responseData && responseData.message) {
        yield put({ type: SEND_PAYMENT_LINK_SUCCESS, data: responseData });
      } else {
        yield put({ type: SEND_PAYMENT_LINK_FAIL, data: {} });
      }
    } catch (error) {
      yield put({ type: SEND_PAYMENT_LINK_FAIL, data: error });
    }
  });
}

export default function* () {
  yield all([
    fork(getPaymentDetails),
    fork(checkUserPayment),
    fork(clearPayment),
    fork(sendPaymentLink),
  ]);
}
